export const categories = [
  { id: 'chinese', name: 'Chinese', emoji: '🥟', chineseName: '中式' },
  { id: 'western', name: 'Western', emoji: '🍝', chineseName: '西式' },
  { id: 'japanese', name: 'Japanese', emoji: '🍣', chineseName: '日式' },
  { id: 'korean', name: 'Korean', emoji: '🍖', chineseName: '韓式' },
  { id: 'thai', name: 'Thai', emoji: '🌶️', chineseName: '泰式' },
  { id: 'indian', name: 'Indian', emoji: '🍛', chineseName: '印度' },
  { id: 'vietnamese', name: 'Vietnamese', emoji: '🍜', chineseName: '越南' },
  { id: 'italian', name: 'Italian', emoji: '🍕', chineseName: '意大利' },
  { id: 'cafe', name: 'Café', emoji: '☕', chineseName: '咖啡廳' },
  { id: 'fastfood', name: 'Fast Food', emoji: '🍔', chineseName: '快餐' },
  { id: 'dessert', name: 'Dessert', emoji: '🍰', chineseName: '甜品' },
  { id: 'bakery', name: 'Bakery', emoji: '🥐', chineseName: '麵包店' },
  { id: 'seafood', name: 'Seafood', emoji: '🦞', chineseName: '海鮮' },
  { id: 'bbq', name: 'BBQ', emoji: '🔥', chineseName: '燒烤' },
  { id: 'hotpot', name: 'Hot Pot', emoji: '🍲', chineseName: '火鍋' },
  { id: 'vegetarian', name: 'Vegetarian', emoji: '🥗', chineseName: '素食' },
  { id: 'breakfast', name: 'Breakfast', emoji: '🥞', chineseName: '早餐' }
];

export const locations = [
  { id: 'central', name: 'Central', chineseName: '中環' },
  { id: 'admiralty', name: 'Admiralty', chineseName: '金鐘' },
  { id: 'wanchai', name: 'Wan Chai', chineseName: '灣仔' },
  { id: 'causewayBay', name: 'Causeway Bay', chineseName: '銅鑼灣' },
  { id: 'tinhau', name: 'Tin Hau', chineseName: '天后' },
  { id: 'mongkok', name: 'Mong Kok', chineseName: '旺角' },
  { id: 'tsimshatsui', name: 'Tsim Sha Tsui', chineseName: '尖沙咀' },
  { id: 'jordan', name: 'Jordan', chineseName: '佐敦' },
  { id: 'yaumatei', name: 'Yau Ma Tei', chineseName: '油麻地' },
  { id: 'princeedward', name: 'Prince Edward', chineseName: '太子' },
  { id: 'sheungwan', name: 'Sheung Wan', chineseName: '上環' },
  { id: 'saiwanho', name: 'Sai Wan Ho', chineseName: '西灣河' },
  { id: 'quarrybay', name: 'Quarry Bay', chineseName: '鰂魚涌' },
  { id: 'taikoo', name: 'Tai Koo', chineseName: '太古' },
  { id: 'shatin', name: 'Sha Tin', chineseName: '沙田' },
  { id: 'taipo', name: 'Tai Po', chineseName: '大埔' },
  { id: 'fanling', name: 'Fan Ling', chineseName: '粉嶺' },
  { id: 'yuenlong', name: 'Yuen Long', chineseName: '元朗' },
  { id: 'tuenmun', name: 'Tuen Mun', chineseName: '屯門' }
];

export const alphabetSections = [
  'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 
  'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '0-9'
];

export const sortOptions = [
  { id: 'distance', name: 'Distance', emoji: '📍' },
  { id: 'rating', name: 'Rating', emoji: '⭐' },
  { id: 'deliveryTime', name: 'Delivery Time', emoji: '⏱️' },
  { id: 'price', name: 'Price', emoji: '💰' },
  { id: 'popular', name: 'Popular', emoji: '🔥' },
  { id: 'topChart', name: 'Top Chart', emoji: '📈' }
]; 